module.exports = vendors_en_4f7915e5587382364d40;